import { useMemo } from 'react';
import { canShowPromotion, PROMO_SURFACES } from '../index';

/**
 * Flight homepage search widget promo — always on when lifecycle allows (no cooldown).
 */
export function useHomepageSearchConvenienceFeePromo({ pathname, isAuthenticated }) {
  const showPromo = useMemo(
    () => canShowPromotion(PROMO_SURFACES.HOMEPAGE_SEARCH_BANNER, {
      pathname,
      isAuthenticated,
    }),
    [pathname, isAuthenticated],
  );

  return { showPromo };
}
